// Value-only enums, kept free of store/Vue imports so paywall instances and build-time tooling
// (tools/generators/paywall-report.ts) can load them in Node without pulling Pinia in.
export enum CrLevel {
	LOW = 'low',
	MID = 'mid',
	HIGH = 'high',
}

export enum WtpLevel {
	LOW = 'low',
	HIGH = 'high',
}
